module.exports = __webpack_public_path__ + "static/media/campbell2.b5914c1a.jpg";